import { Container } from "./Container";
import { CodePanel } from "./CodePanel";
import { Tag } from "./Tag";
import { Button } from "./Button";
import { codePanel, siteConfig } from "../data/portfolio";

export function AboutSection() {
  return (
    <section
      id="about"
      className="border-hairline bg-band border-y py-16 md:py-24"
    >
      <Container>
        <div className="grid items-center gap-10 lg:grid-cols-[minmax(22rem,0.85fr)_minmax(0,1.15fr)] lg:gap-16">
          <CodePanel {...codePanel} />
          <div>
            <p className="text-accent text-sm font-semibold tracking-eyebrow uppercase">
              About
            </p>
            <h2 className="text-strong mt-4 text-2xl leading-tight font-semibold tracking-tight text-balance md:text-4xl">
              Thoughtful systems. Polished interactions. Steady iteration.
            </h2>
            <div className="text-body mt-7 grid gap-5 text-lg leading-8">
              {siteConfig.about.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
            <div className="mt-8 flex flex-wrap gap-2">
              {siteConfig.aboutTags.map((tag) => (
                <Tag key={tag}>{tag}</Tag>
              ))}
            </div>
            <div className="mt-8 flex flex-wrap gap-3">
              <Button
                variant="primary"
                icon="mail"
                iconPosition="left"
                href="#contact"
              >
                Contact me
              </Button>
              <Button variant="ghost" icon="arrow" href="#projects">
                See the work
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
